"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = delay;
async function delay(ms) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
}
//# sourceMappingURL=delay.js.map